import BaseError from "./BaseError";

export default class GatewayTimeoutError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "GatewayTimeoutError";
  }
}
